// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-symbol[data-v-dc5f74c4]{width:2.5rem;justify-content:center}.currency-select[data-v-dc5f74c4]{flex:0 1 content}`, "",{"version":3,"sources":["webpack://./client/components/Inputs/InputPrice.vue"],"names":[],"mappings":"AAGA,kCACE,YAAA,CACA,sBAAA,CAGF,kCACE,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
